var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadar5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 121,
    viewBox: "0 0 126 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1886 120.119C29.1196 120.119 2.93061 94.535 1.91562 62.708C1.04362 62.506 0.393616 61.729 0.393616 60.797C0.393616 27.273 27.6656 0 61.1886 0C62.1226 0 62.8986 0.650996 63.0996 1.522C94.9286 2.537 120.513 28.727 120.513 60.797C120.513 93.507 93.9006 120.119 61.1886 120.119ZM63.0706 2.504C62.8346 3.325 62.0866 3.93 61.1886 3.93C29.8346 3.93 4.32362 29.441 4.32362 60.797C4.32362 61.694 3.71962 62.443 2.89762 62.678C3.89662 93.978 29.6516 119.136 61.1886 119.136C93.3576 119.136 119.531 92.966 119.531 60.797C119.531 29.259 94.3696 3.503 63.0706 2.504ZM61.1886 74.779C53.4786 74.779 47.2066 68.507 47.2066 60.797C47.2066 53.087 53.4786 46.813 61.1886 46.813C68.9006 46.813 75.1736 53.087 75.1736 60.797C75.1736 68.507 68.9006 74.779 61.1886 74.779ZM61.1886 48.778C54.5636 48.778 49.1716 54.17 49.1716 60.797C49.1716 67.423 54.5636 72.814 61.1886 72.814C67.8166 72.814 73.2076 67.423 73.2076 60.797C73.2076 54.17 67.8166 48.778 61.1886 48.778Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.401 70.6806C109.401 42.4871 86.8497 19.6328 59.0327 19.6328V70.6806H109.401Z",
    fill: "#2E18EE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 43.0327,
    y: 7.63281,
    width: 82.368,
    height: 83.0479,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0999163 0 0 0 0 0.0302041 0 0 0 0 0.721517 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadar5);
export default __webpack_public_path__ + "static/media/radar5.2d6b28c0250e99ac0adc8791f8479b9b.svg";
export { ForwardRef as ReactComponent };